import BaseAbility from './base-ability';
import { PREFIX_PACKER_CHANNELS } from '../utils/permission-types/index';

export default class extends BaseAbility {
  prefix = PREFIX_PACKER_CHANNELS;
}
